export default __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/loader_VA.0c3d0198.gif";